<template>
  <div class="subdriver-overvierw-wrap">
    <div class="wrap-title">
      Which sub-drivers are affecting engagement score the most?
      <div class="info-icon pt-5" name="Engagement4" style="display: initial;">
        <i class="las la-info-circle ls-4"></i>
      </div>
      <tippy to="Engagement4"
        interactive="true"
        theme="light amara"
        class="am-tool"
        :allowHTML="true"
        arrow
        placement="right"
      >
        <p>
          Get an in-depth analysis of how various sub-
drivers are impacting the overall employee experience. This detailed
report will help augment the HR practices by identifying the actionable
items.
        </p>
      </tippy>
    </div>
    <v-row>
      <v-col class="sub-drivers-wrap">
        <div
          v-if="dashboardData.sub_drivers_analysis &&
          dashboardData.sub_drivers_analysis.positive_sub_driver_analysis"
        >
          <v-row no-gutters class="sub-driver-body good">
            <v-col cols="6" class="drivers-title">
              <div class="drivers-title-great">You're doing great with</div>
            </v-col>
            <v-col cols="3" class="driver-engagement">
              Engagement Score
            </v-col>
            <v-col cols="3" class="driver-response">
              Negative Responses
            </v-col>
          </v-row>
          <div class="sub-drivers-list good" v-if="dashboardData.sub_drivers_analysis">
            <v-row no-gutters class="sub-driver-wrap"
              v-for="(sd, index) in dashboardData.sub_drivers_analysis.positive_sub_driver_analysis"
              :key="index"
            >
              <v-col cols="6" style="cursor: pointer;" @click="viewSubdriver(sd.driver_name, sd.sub_driver_name)">
                <div class="sd-title">{{sd.sub_driver_name.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</div>
                <h6 class="d-title">Driver: {{sd.driver_name.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</h6>
              </v-col>
              <v-col cols="3" class="d-score">
                <span v-if="sd.sub_driver_average">
                  {{sd.sub_driver_average.toFixed(1)}}
                </span>
                <span v-else>0</span>
              </v-col>
              <v-col cols="3" class="d-score">
                <span v-if="sd.negative_responses">{{sd.negative_responses}}</span>
                <span v-else>0</span>
              </v-col>
            </v-row>
          </div>
        </div>
        <div v-else class="am-no-data">
          {{noDataText}}
        </div>
      </v-col>
      <v-col class="sub-drivers-wrap sub-driver-divider">
        <div
        v-if="dashboardData.sub_drivers_analysis &&
          dashboardData.sub_drivers_analysis.negative_sub_driver_analysis"
        >
          <v-row no-gutters class="sub-driver-body bad">
            <v-col cols="6" class="drivers-title">
              <div class="drivers-title-loss">
                Improve Your Focus On
              </div>
            </v-col>
            <v-col cols="3" class="driver-engagement">
              Engagement Score
            </v-col>
            <v-col cols="3" class="driver-response">
              Negative Responses
            </v-col>
          </v-row>
          <div class="sub-drivers-list bad"
            v-if="dashboardData.sub_drivers_analysis"
          >
            <v-row no-gutters class="sub-driver-wrap"
              v-for="(sd, index) in dashboardData.sub_drivers_analysis.negative_sub_driver_analysis"
              :key="index"
            >
              <v-col cols="6" style="cursor: pointer;" @click="viewSubdriver(sd.driver_name, sd.sub_driver_name)">
                <div class="sd-title">{{sd.sub_driver_name.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</div>
                <h6 class="d-title">Driver: {{sd.driver_name.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</h6>
              </v-col>
              <v-col cols="3" class="d-score">
                <span v-if="sd.sub_driver_average">
                  {{sd.sub_driver_average.toFixed(1)}}
                </span>
                <span v-else>0</span>
              </v-col>
              <v-col cols="3" class="d-score">
                <span v-if="sd.negative_responses">{{sd.negative_responses}}</span>
                <span v-else>0</span>
              </v-col>
            </v-row>
          </div>
        </div>
        <div v-else class="am-no-data">
          {{noDataText}}
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OverviewMixin from './overview-mixin';

export default {
  name: 'SubdriverOverview',

  mixins: [OverviewMixin],

  methods: {
    viewSubdriver (driver, subdriver) {
      this.$store.dispatch('UpdateStage', this.$route.query.stage);
      const temp = {
        stage__title__in: this.$route.query && this.$route.query.stage ? this.$route.query.stage : undefined,
        ...this.updateDashboardFilters
      };
      console.log(temp);
      this.$router.push({
        path: '/drivers/view/subdriver',
        query: {
          driver,
          subdriver,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.subdriver-overvierw-wrap {
  margin-top: 16px;
  background: var(--bg);
  padding: 16px;
  border-radius: 6px;
  // box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08) !important;
  box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  height: 20rem;
  .am-no-data {
    height: 15rem;
  }
  .wrap-title {
    padding: 8px 4px;
    // font-size: var(--content-size);
    font-size: 20px;
    color: var(--color-text);
  }
  .sub-drivers-wrap {
    .sub-driver-body {
      &.good, &.bad {
        .driver-engagement,
        .driver-response,
        .drivers-title {
          font-size: var(--content-sub-size);
          color: var(--color-text);
          display: flex;
          padding: 0 4px;
          align-items: center;
          .drivers-title-great {
            padding: 4px;
            border-radius: 0.25rem;
            color: var(--color-text);
            font-size: var(--content-sub-size);
            box-shadow:
            2px 2px 6px 0 #ebe9ff,
            -2px -2px 6px 0 #ebe9ff;
            background-color: rgba(100, 231, 100, 0.2);
            font-weight: 500;
          }
          .drivers-title-loss {
            padding: 4px;
            border-radius: 0.25rem;
            font-weight: 500;
            color: var(--color-text);
            font-size: var(--content-sub-size);
            box-shadow:
            2px 2px 6px 0 #ebe9ff,
            -2px -2px 6px 0 #ebe9ff;
            background-color: rgba(244, 67, 54, 0.2);
          }
        }
      }
      &.good {
        .drivers-title {
          // font-weight: var(--heading-weight);
          // color: #4caf50;
          color: rgba(100, 231, 100, 0.99);
        }
      }
      &.bad {
        .drivers-title {
          // font-weight: var(--heading-weight);
          // color: #f44336;
          color: rgba(244, 67, 54, 0.8);
        }
      }
    }
    .sub-drivers-list {
      padding: 0 4px;
      .sub-driver-wrap {
        padding: 8px 0;
        .sd-title {
          font-size: var(--content-sub-size);
          color: var(--color-text);
          font-weight: var(--heading-weight);
        }
        .d-title {
          font-size: var(--content-sub-size);
          color: var(--color-palceholder);
        }
        .d-score {
          font-weight: var(--heading-weight);
          font-size: var(--content-sub-size);
          color: var(--color-text);
          padding: 0 16px;
          margin: auto;
        }
      }
    }
  }
  .sub-driver-divider {
    border-left: 1px solid rgba(0,0,0,0.1);
  }
}
</style>

<style scoped>
.sub-drivers-wrap[min-width~="370px"] .drivers-title {
  font-size: 13px !important;
}
.sub-drivers-wrap[min-width~="370px"] .sub-driver-body .driver-engagement {
  font-size: 13px !important;
}
.sub-drivers-wrap[min-width~="370px"] .sub-driver-body .driver-response {
  font-size: 13px !important;
}
.sub-drivers-wrap[min-width~="370px"] .d-title {
  font-size: 12px !important;
}
</style>
